const HeadingBlock = ({
  heading,
  children,
  actions,
}: {
  heading: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}) => {
  return (
    <div className="et-analytics-section">
      <div className="et-analytics-section-heading">
        <h2>{heading}</h2>
        {actions}
      </div>
      {children}
    </div>
  );
};

export default HeadingBlock;
